<template>
  <!-- 车辆保险 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems" @click="clickAdd({})">新增</el-button>
        <el-button class="glo_btnItems" @click="clickDels()">批量删除</el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns :MoreConditions="MoreConditions" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition ref="queryForm" :More="isHaseMore" :formConfig="queryCondditionDatas"></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="clickAdd(scope.row)">修改</el-button>
              <el-button class="rbtns" @click.stop="clickDels(scope.row)">删除</el-button>
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 新增修改 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch"
    >
      <div class="formbox" v-if="isShowDialogDispatch">
        <el-form class="glo_formBox" label-width="120px">
          <div class="formBox_item">
            <el-form-item required label="车牌号码:">
              <el-select filterable clearable allow-create remote v-model="dialogFormDispatch.carNumber" placeholder="请选择">
                <el-option v-for="(item, index) in carNumberList1" :key="index" :label="item.carNumber" :value="item.carNumber"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保险险种:" required>
              <el-select v-model="dialogFormDispatch.insuranceCoverage" placeholder="请选择" filterable clearable allow-create default-first-option>
                <el-option v-for="(item, index) in insuranceCoverageArrs" :key="index" :label="item.key" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保险公司:" required>
              <el-input v-model="dialogFormDispatch.company" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div class="formBox_item">
            <el-form-item label="到期时间:" required>
              <el-date-picker v-model="dialogFormDispatch.insuranceDateEnd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
            </el-form-item>
            <el-form-item label="保险单号:" required>
              <el-input v-model="dialogFormDispatch.insuranceNumber" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="本年度费用:" required>
              <el-input v-model="dialogFormDispatch.annualCharge" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input type="textarea" v-model="dialogFormDispatch.remarks"></el-input>
          </el-form-item>
          <div class="uploadBox" style="width: 100%">
            <div class="uploadItem">
              <div class="uploadLaber" style="margin-right: 10px">图片:</div>
              <uploadimgs @input="changeFileList" :fileNameLists="fileNameLists" :limit="9"></uploadimgs>
            </div>
          </div>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    ></exportCompoent>
  </div>
</template>
<script>
import tableList from "@/pages/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    uploadimgs,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "车辆保险", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "VMS_VehicleInsurance", //  页面标识
      reportFiledsNumber: "admin_car_insurance_list", // 动态 条件、表头

      isShowDialogDispatch: false,
      dialogTitleDispatch: "新增",
      diaWidthDispatch: "60%",
      dialogFormDispatch: {
        carNumber: "",
        insuranceCoverage: "",
        company: "",
        insuranceDateEnd: "",
        insuranceNumber: "",
        annualCharge: "",
        remarks: "",
      },

      out_going_billing_method_list: [],
      carNumberList1: [], //车牌号码
      fileNameLists: [],
      insuranceCoverageArrs: [],
    };
  },
  mounted() {
    this.getConfDictValDownList("car_insurance_type");
    this.getConfDictValDownList("out_going_billing_method");
    this.changecarCategoryConfDictId();
  },
  watch: {},
  methods: {
    changeFileList(array) {
      this.fileNameLists = array;
    },
    async clickAdd({ insuranceId }) {
      if (insuranceId) {
        this.dialogTitleDispatch = "修改";
        await this.$API.getCarInsuranceDetail({ insuranceId }).then((res) => {
          let datas = res.data.result[0] || {};
          this.dialogFormDispatch = datas;
          this.dialogFormDispatch.insuranceId = insuranceId;
          let fileList = datas.fileList || [];
          let arrs = fileList.map((item) => {
            return {
              name: item.fileId,
              url: item.fileUrl,
            };
          });
          this.fileNameLists = arrs;
        });
      } else {
        this.dialogTitleDispatch = "新增";
      }
      this.isShowDialogDispatch = true;
    },
    handleCloseDiaDispatch() {
      this.isShowDialogDispatch = false;
      this.fileNameLists = [];
      this.dialogFormDispatch = {
        carNumber: "",
        insuranceCoverage: "",
        company: "",
        insuranceDateEnd: "",
        insuranceNumber: "",
        annualCharge: "",
        remarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch() {
      const {
        company,
        insuranceCoverage,
        carNumber,
        insuranceDateEnd,
        insuranceId,
      } = this.dialogFormDispatch;
      if (!carNumber) {
        this.$message.error("请选择车牌号码");
        return false;
      }
      if (!insuranceCoverage) {
        this.$message.error("请选择保险险种");
        return false;
      }
      if (!company) {
        this.$message.error("请输入保险公司");
        return false;
      }
      if (!insuranceDateEnd) {
        this.$message.error("请选择到期时间");
        return false;
      }
      let curs = this.carNumberList1.filter(
        (item) => item.carNumber == carNumber
      );
      this.dialogFormDispatch.carId = (curs.length && curs[0].carId) || "";
      this.dialogFormDispatch.fileIds = this.fileNameLists.map((item) => {
        return item.name;
      });
      if (insuranceId) {
        this.$API.updateCarInsurance(this.dialogFormDispatch).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialogDispatch = false;
          this.getData();
        });
      } else {
        this.$API.addCarInsurance(this.dialogFormDispatch).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialogDispatch = false;
          this.getData();
        });
      }
    },
    clickDels(data) {
      console.log(data);
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      }
      let insuranceIds = [];
      this.selectTableData.forEach((item) => {
        insuranceIds.push(item.insuranceId);
      });
      this.$confirm("确定要删除所选数据吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API.delCarInsurance({ insuranceIds }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch((err) => {});
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(type) {
      this.$COMAPI.getConfDictValDownList(type).then((res) => {
        //
        if (type == "car_insurance_type") {
          this.insuranceCoverageArrs = res || [];
        }
        if (type == "out_going_billing_method") {
          //送货方式
          this.out_going_billing_method_list = res || [];
        }
      });
    },
    // 获取车辆下拉列表(拿车牌号码)
    changecarCategoryConfDictId() {
      this.$API
        .CarDownList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: "",
        })
        .then((res) => {
          this.carNumberList1 = res.data.result.data || [];
        });
    },
  },
};
</script>
<style scoped lang="less">
.textArea {
  height: auto !important;
}
.formBox_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-form-item {
    width: 32%;
  }
}
.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}
</style>